import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

/**
 * Hook per verificare l'email di un utente
 * Supporta due modalità:
 * 1. Verifica admin tramite userId
 * 2. Verifica utente tramite link di conferma
 * 
 * @param {Object} options - Opzioni per la mutation
 * @param {Function} options.onSuccess - Callback di successo
 * @param {Function} options.onError - Callback di errore
 * @returns {Object} Mutation object di React Query
 */
export const useVerifyEmail = (options = {}) => {
  const queryClient = useQueryClient();
  const localPrefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (params) => {
      // Supporta sia { userId } che { link }
      const payload = {};
      
      if (params.userId) {
        payload.firestoreId = params.userId;
      } else if (params.link) {
        payload.firestoreId = params.link;
      } else {
        throw new Error('Either userId or link must be provided');
      }

      const response = await restClient({
        url: `${localPrefix}/auth/verify-email`,
        method: 'post',
        data: payload
      });
      return response;
    },
    onSuccess: (data, variables) => {
      // Invalida le cache degli utenti per aggiornare lo stato di verifica
      if (variables.userId) {
        queryClient.invalidateQueries({ queryKey: ['user', variables.userId] });
        queryClient.invalidateQueries({ queryKey: ['userById', variables.userId] });
      }
      queryClient.invalidateQueries({ queryKey: ['users'] });
      
      // Chiama il callback di successo se fornito
      if (options.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
    onError: (error, variables) => {
      console.error('Error verifying email:', error);
      
      // Chiama il callback di errore se fornito
      if (options.onError) {
        options.onError(error, variables);
      }
    },
    ...options
  });
};
